import Vue from "vue";
import VueRouter from "vue-router";

// 页面组件
import Layout from "@/views/layout/Index.vue";
import Login from "@/views/login/Index.vue";
import Home from "@/views/home/Home.vue";

Vue.use(VueRouter);

// 解决重复点击报错
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function (location) {
  return routerPush.call(this, location).catch(err => err);
};

// 懒加载
const List = () => import("@/views/product/list/Index.vue");
const AddProduct = () => import("@/views/product/list/AddProduct.vue");
const HomeConfig = () => import("@/views/home-config/Index.vue");

// 所有路由
const routes = [
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "home",
        name: "home",
        component: Home,
        meta: {
          title: "首页",
        },
      },
 // 新增：首页配置（与首页平级）
      {
        path: "home-config",
        name: "homeConfig",
        component: HomeConfig,
        meta: {
          title: "首页配置",
        },
      },
      {
        path: "product",
        component: { render: h => h("router-view") },
        redirect: "/product/list",
        meta: {
          title: "价目管理",
        },
        children: [
          {
            path: "list",
            name: "list",
            component: List,
            meta: {
              title: "价目列表",
            },
          },
          {
            path: "add-product",
            name: "addProduct",
            component: AddProduct,
            meta: {
              title: "添加价目",
              activeMenu: "/product/list",
            },
          },
        ],
      },
    ],
  },

  {
    path: "*",
    redirect: "/home",
  },
];

// 创建路由
const createRouter = () => new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const router = createRouter();

// 👇👇👇 【修复报错关键代码】导出菜单需要的 2 个东西
// 导出基础路由
export const baseRoutes = routes;

// 导出重置路由方法
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}
// 👆👆👆 修复完成

router.beforeEach((to, from, next) => {
  const whiteList = ['/login'];
  const token = localStorage.getItem('token');

  if (whiteList.includes(to.path)) {
    next();
  } else {
    if (token) {
      next();
    } else {
      next('/login');
    }
  }
});

export default router;